import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Csr.css";
import { logHistory } from "../../utils/historyLogger";

function CSR() {
  const [csrData, setCsrData] = useState([]);
  const role = localStorage.getItem("role");
  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  // Any logged-in role (user, admin, superadmin) can add data now.
  const canAdd = role === "user" || role === "admin" || role === "superadmin";

  const [date, setDate] = useState("");
  const [activity, setActivity] = useState("");
  const [beneficiaries, setBeneficiaries] = useState("");
  const [totalCost, setTotalCost] = useState("");
  const [focusArea, setFocusArea] = useState("");
  const [remarks, setRemarks] = useState("");
  const [search, setSearch] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchCSR();
  }, []);

  const fetchCSR = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/csr");
      setCsrData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  const clearForm = () => {
    setDate("");
    setActivity("");
    setBeneficiaries("");
    setTotalCost("");
    setFocusArea("");
    setRemarks("");
    setEditingId(null);
  };
    const handleSubmit = async () => {
    try {
      const payload = {
        date,
        activity,
        beneficiaries: Number(beneficiaries) || 0,
        totalCost: Number(totalCost) || 0,
        focusArea,
        remarks,
      };

      if (editingId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/csr/${editingId}`,
          payload
        );

        await logHistory(
          "CSR",
          "Updated CSR Record",
          "CSR record updated"
        );

        alert("CSR Updated Successfully");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/csr", payload);

        await logHistory(
          "CSR",
          "Added CSR Record",
          "CSR record added"
        );

        alert("CSR Added Successfully");
      }

      fetchCSR();
      clearForm();
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Error Saving CSR");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this CSR record?")) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/csr/${id}`);

      await logHistory(
        "CSR",
        "Deleted CSR Record",
        "CSR record deleted"
      );

      fetchCSR();
    } catch (err) {
      console.log(err);
      alert("Delete Failed");
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setDate(item.date || "");
    setActivity(item.activity || "");
    setBeneficiaries(item.beneficiaries || "");
    setTotalCost(item.totalCost || "");
    setFocusArea(item.focusArea || "");
    setRemarks(item.remarks || "");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const downloadCSVReport = () => {
    if (csrData.length === 0) {
      alert("No CSR data to download");
      return;
    }

    const headers = Object.keys(csrData[0]);

    const rows = csrData.map((item) =>
      headers
        .map((field) => `"${String(item[field] ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "csr_report.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const filteredData = csrData.filter((item) =>
    item.activity?.toLowerCase().includes(search.toLowerCase())
  );

  const totalActivities = csrData.length;

  const totalBeneficiaries = csrData.reduce(
    (total, item) => total + Number(item.beneficiaries || 0),
    0
  );

  const totalYearCost = csrData.reduce(
    (total, item) => total + Number(item.totalCost || 0),
    0
  );
    return (
    <div className="visitor-page">
      <h1 className="page-title">CSR Management</h1>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Total Activities</h3>
          <h1>{totalActivities}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Total Beneficiaries</h3>
          <h1>{totalBeneficiaries}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Year Total Cost</h3>
          <h1>Rs. {totalYearCost}</h1>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search Activity"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>

        {/* Download available to every role - user downloads their own
            assigned-interface data, admin/superadmin download any interface */}
        <button className="add-btn" onClick={downloadCSVReport}>
          Download Report
        </button>
      </div>

      {/* Add form: user, admin, and superadmin can all add data now.
          The same form is reused for editing an existing record
          (editingId gets set by handleEdit). */}
      {(canAdd || editingId) && (
        <div className="form-container">
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />

          <input
            type="text"
            placeholder="Nature of Activity"
            value={activity}
            onChange={(e) => setActivity(e.target.value)}
          />

          <input
            type="number"
            placeholder="No of Beneficiaries"
            value={beneficiaries}
            onChange={(e) => setBeneficiaries(e.target.value)}
          />

          <input
            type="number"
            placeholder="Total Cost"
            value={totalCost}
            onChange={(e) => setTotalCost(e.target.value)}
          />

          <input
            type="text"
            placeholder="Focus Area"
            value={focusArea}
            onChange={(e) => setFocusArea(e.target.value)}
          />

          <input
            type="text"
            placeholder="Remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />

          <button className="add-btn" onClick={handleSubmit}>
            {editingId ? "Update CSR" : "Add CSR"}
          </button>

          <button className="clear-btn" onClick={clearForm}>
            Clear Form
          </button>
        </div>
      )}

      <div className="table-container">
        <div className="table-title">CSR Activities</div>

        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Nature of Activity</th>
              <th>Beneficiaries</th>
              <th>Total Cost</th>
              <th>Focus Area</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.activity}</td>
                <td>{item.beneficiaries}</td>
                <td>Rs. {item.totalCost}</td>
                <td>{item.focusArea}</td>
                <td>{item.remarks}</td>

                <td>
                  {canEdit && (
                    <button
                      className="edit-btn"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                  )}

                  {canDelete && (
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="total-cost-bar">
        Total CSR Cost : Rs. {totalYearCost}
      </div>
    </div>
  );
}

export default CSR;